import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedBusinesses from './components/FeaturedBusinesses';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '黄页网站免费入口91 - 首页',
            description: '黄页网站免费入口91为您提供最便捷的企业信息免费发布通道，快速收录公司名称、联系方式、经营范围等信息。',
            url: 'https://lc0001.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '黄页网站免费入口91',
              url: 'https://lc0001.cn',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedBusinesses />
          <section className="bg-accent-500 py-14 md:py-16">
            <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-white font-heading">
                立即免费收录您的企业信息
              </h2>
              <p className="mt-3 text-white/85 text-sm max-w-xl mx-auto">
                加入黄页网站免费入口91，让更多客户找到您。完全免费，操作简单，立即获取在线曝光机会。
              </p>
              <a
                href="#"
                className="mt-6 inline-flex items-center gap-2 bg-white text-accent-600 px-8 py-3 rounded-full text-sm font-semibold hover:bg-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                免费收录企业
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </a>
            </div>
          </section>
          <LatestArticles />
        </main>
        <Footer />
      </div>
    </>
  );
}